export default __webpack_public_path__ + "static/employers-568a83634adae5402a3a9c3efed5e219.jpg";